import { Routes, Route } from 'react-router-dom'

import PaywallDetails from 'pages/paywall/PaywallDetails'
import PaywallOptions from 'pages/paywall/PaywallOptions'
import PaywallAccount from 'pages/paywall/PaywallAccount'
import PaywallStatements from 'pages/paywall/PaywallStatements'

const PaywallRouter = () => {
  return (
    <Routes>
      <Route path={'details/:dealerId'} element={<PaywallDetails />} />
      <Route path={'options/:dealerId'} element={<PaywallOptions />} />
      <Route path={'account/:dealerId/:planNo/:planType'} element={<PaywallAccount />} />
      <Route path={'statements/:dealerId'} element={<PaywallStatements />} />
    </Routes>
  )
}

export default PaywallRouter
